module.exports = __webpack_public_path__ + "static/mestrovic-thumbnail-999bfa43e7ea3e75b7a8fc22e4b014a3.jpg";